import React, { useState } from "react";

import {
  Box,
  Collapse,
  IconButton,
  makeStyles,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { RecetasDigitalesHistorialMedicamento } from "./RecetasDigitalesHistorialMedicamento";

const useStyles = makeStyles({
  iconEstado: {
    "&:hover": {
      backgroundColor: "#80808026",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const RecetasDigitalesHistorialItem = (props) => {
  const classes = useStyles();

  const [openMedicamentoInfo, setOpenMedicamentoInfo] = useState(false);

  const { receta } = props;

  return (
    <React.Fragment>
      <TableRow className={classes.iconEstado}>
        <TableCell>{receta?.finalizada ? "Generada" : "En carga"}</TableCell>
        <TableCell>{receta?.idRecetaDigital}</TableCell>
        <TableCell>
          {new Date(receta?.fecha).toLocaleString("es", optionsfecha)}
        </TableCell>
        <TableCell align="left">{receta?.tipoRecetasDigitales?.descripcion}</TableCell>
        <TableCell align="left">{receta.duplicada ? "Si" : "No"}</TableCell>
        <TableCell align="left">{receta.subtipoRecetasDigitales?.descripcion}</TableCell>
        <TableCell align="left">{receta.tratamientoProlongado ? "Si" : "No"}</TableCell>
        <TableCell>
          {receta?.medicamentos?.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() =>
                setOpenMedicamentoInfo(
                  (prevOpenMedicamentoInfo) => !prevOpenMedicamentoInfo
                )
              }
            >
              {openMedicamentoInfo ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          )}
        </TableCell>
        <TableCell>{receta?.diagnostico?.problema}</TableCell>
        {<TableCell>{receta?.usuario?.userName}</TableCell>}
      </TableRow>
      <TableRow>
        <TableCell
          style={{
            paddingBottom: 0,
            paddingTop: 0,
            paddingLeft: 50,
          }}
          colSpan={8}
        >
          <Collapse in={openMedicamentoInfo} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Medicamentos
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Codigo</TableCell>
                    <TableCell>Presentación</TableCell>
                    <TableCell>Laboratorio</TableCell>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Drogas</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell>Dosis</TableCell>
                    <TableCell>Posología</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(receta?.medicamentos) &&
                    receta?.medicamentos?.length > 0 &&
                    receta?.medicamentos?.map((medicamento) => (
                      <RecetasDigitalesHistorialMedicamento
                        key={medicamento?.idMedicamento}
                        medicamento={medicamento}
                      />
                    ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
